import { useState } from 'react';
import Text from '../../../atoms/Text';
import TableCardMobile, {
  ITableCard,
} from '../../../molecules/Table/mobile/TableCard';
import TableHeaderMobile from '../../../molecules/Table/mobile/TableHeader';
import { IMobileTableScema } from '../../../helpers/formatters';

interface IPairsTableProps {
  title?: string;
  data: ITableCard[];
  schema: IMobileTableScema;
}

const PairsTable = ({ title, data, schema }: IPairsTableProps) => {
  const [showMarkets, setShowMarkets] = useState(false);

  return (
    <div className='mobile_seo_page__table'>
      {title && (
        <div className='mobile_seo_page__table__title'>
          <Text size={18} className='text--grey-200 text--weight-500'>
            {title}
          </Text>
        </div>
      )}
      <div className='mobile_seo_page__table__content'>
        <TableHeaderMobile schema={schema} />
        {data?.slice(0, 10).map((row, index) => (
          <TableCardMobile key={index} data={row} />
        ))}
        {showMarkets &&
          data?.slice(10).map((row, index) => (
            <div
              key={index}
              className='mobile_seo_page__table__content__second_part'
            >
              <TableCardMobile data={row} />
            </div>
          ))}
      </div>
      <div className='mobile_seo_page__table__additional'>
        <Text size={12} className='text--grey-400'>
          Do Your Own Research, Markets can move very quickly and it takes time
          to build your knowledge.
        </Text>
        {data.length > 10 && (
          <div
            className='mobile_seo_page__table__additional__btn'
            onClick={() => setShowMarkets(!showMarkets)}
          >
            <Text size={12} className='text--weight-600 text--white'>
              {showMarkets ? 'Hide' : 'See All Markets'}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default PairsTable;
